module.exports = __webpack_public_path__ + "static/media/share.e7013d5a.svg";